import { render, staticRenderFns } from "./12-member-profile-extras.vue?vue&type=template&id=05c39759&scoped=true"
import script from "./12-member-profile-extras.vue?vue&type=script&lang=js"
export * from "./12-member-profile-extras.vue?vue&type=script&lang=js"
import style0 from "./12-member-profile-extras.vue?vue&type=style&index=0&id=05c39759&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c39759",
  null
  
)

export default component.exports